import { createSlice } from '@reduxjs/toolkit';

const adManagerLoadingSlice = createSlice({
  name: 'adManagerLoading',
  initialState: true,
  reducers: {
    setAdManagerLoading(_state, action) {
      return action.payload;
    }
  }
});

export const { setAdManagerLoading } = adManagerLoadingSlice.actions;

export default adManagerLoadingSlice.reducer;
